import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TimeDistributionResponse } from '../../models/time-distribution.models';

@Injectable({
  providedIn: 'root'
})
export class TimeDistributionService {
  private apiUrl = `${environment.main_url}/agilelegal/reports/tasks/overall-time-distribution`;

  constructor(private http: HttpClient) { }

  getTimeDistributionData(filters: any): Observable<TimeDistributionResponse> {
    return this.http.get<TimeDistributionResponse>(this.apiUrl)
      .pipe(
        catchError(error => {
          console.error('Error fetching time distribution data:', error);
          return of({ 
            data: [], 
            message: 'Failed to fetch time distribution data',
            customValues: null
          });
        })
      );
  }
}
